import { render, staticRenderFns } from "./OtpConfirm.vue?vue&type=template&id=f5f983f8"
import script from "./OtpConfirm.vue?vue&type=script&lang=js"
export * from "./OtpConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports